export default __webpack_public_path__ + "static/media/process.6b35d384.png";